import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import '../../App.css';
import GreenGreyLightIcon from '../../components/GreenGreyLightIcon';
import { Styles, StyleConstants } from '../../Styles';
import Decimal from 'decimal.js';
import { Stack } from '@mui/material';

const CarAuxiliarySystemTab = (props) => {
    const { packet, car } = props;
    
    return (
        <>
            {(packet.board1 !== null) && (
                <Stack direction="column">
                    <TableContainer component={Paper} sx={{ height: 'calc(100% - 40px)' }}>
                        <Table size='small' sx={{ border: '3px solid ' + StyleConstants.borderColor }}>
                            <TableHead>
                                <TableRow sx={{ '& th': { color: '#FFFFFF', backgroundColor: StyleConstants.mainBgColor } }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        Auxiliary Power Supply (SIV)
                                    </TableCell>
                                    <TableCell sx={{ width: '100px', borderLeft: '2px solid ' + StyleConstants.borderColor }}>
                                        Unit 1
                                    </TableCell>

                                    <TableCell sx={{ ...Styles.carBorderCellRight }}>
                                        Auxiliary Power Supply (SIV)
                                    </TableCell>
                                    <TableCell sx={{ width: '100px', borderLeft: '2px solid ' + StyleConstants.borderColor }}>
                                        Unit 1
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        Energy Consumption (kWh) (1kWh/pulse)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {car.sivPowering}
                                    </TableCell>

                                    <TableCell sx={Styles.carBorderCellRight}>
                                        Input Current (IL)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {new Decimal(packet.board1.siv.inCurr).toFixed(1)}A
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        SIV Start Command On (SIVON)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCell}>
                                        <GreenGreyLightIcon onOffBit={packet.board1.siv.sivStartComOn} onLabel="On" offLabel="Off" />
                                    </TableCell>

                                    <TableCell sx={Styles.carBorderCellRight}>
                                        Out Voltage Phase U-V (VUV)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {new Decimal(packet.board1.siv.outVolt).toFixed(1)}V
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        IVK Contactor On (IVKON)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCell}>
                                        <GreenGreyLightIcon onOffBit={packet.board1.siv.ivkContactorOn} onLabel="On" offLabel="Off" />
                                    </TableCell>

                                    <TableCell sx={Styles.carBorderCellRight}>
                                        Output Current Phase U (IOU)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {new Decimal(packet.board1.siv.outCurr).toFixed(1)}A
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        Blocking Thyristor On (BTHON)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCell}>
                                        <GreenGreyLightIcon onOffBit={packet.board1.siv.blockThyOn} onLabel="On" offLabel="Off" />
                                    </TableCell>

                                    <TableCell sx={Styles.carBorderCellRight}>
                                        Output Frequency (FR)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {new Decimal(packet.board1.siv.outFreq).toFixed(1)}Hz
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        Inverter Start Command On (INVON)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCell}>
                                        <GreenGreyLightIcon onOffBit={packet.board1.siv.invStartComOn} onLabel="On" offLabel="Off" />
                                    </TableCell>

                                    <TableCell sx={Styles.carBorderCellRight}>
                                        Input Voltage for Inverter Circuit (VI)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {new Decimal(packet.board1.siv.inVolt).toFixed(1)}V
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        Battery Charger On (BCON)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCell}>
                                        <GreenGreyLightIcon onOffBit={packet.board1.siv.battChargerOn} onLabel="On" offLabel="Off" />
                                    </TableCell>

                                    <TableCell sx={Styles.carBorderCellRight}>
                                        Battery Charger Output Voltage (VB)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {new Decimal(packet.board1.siv.battVolt).toFixed(1)}V
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        Line Voltage (VL)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {new Decimal(packet.board1.siv.lineVolt).toFixed(1)}V
                                    </TableCell>

                                    <TableCell sx={Styles.carBorderCellRight}>
                                        Battery Charger Output Current (IB)
                                    </TableCell>
                                    <TableCell sx={Styles.carBorderCellRight}>
                                        {new Decimal(packet.board1.siv.battCurr).toFixed(1)}A
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Stack>
            )}
        </>
    );
};

export default CarAuxiliarySystemTab;